import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-secondary-900 mb-4">404</h1>
        <p className="text-xl text-secondary-600">Page not found</p>
      </div>
    </div>
  );
};

export default NotFoundPage; 